module.exports = ".card{width:16rem;margin-left:1rem;margin-bottom:1rem;height:22rem}.card-header{padding:0.3rem;font-size:0.7rem;height:5rem}.card-body{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0.3rem;font-size:0.7rem;overflow-y:auto;height:100%;text-align:center}.kpi-value-large{font-size:4rem}.kpi-value-normal{font-size:3rem}.kpi-value-small{font-size:2rem}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/kpi/kpi.component.sass
// module id = ./src/app/modules/dashboard/kpi/kpi.component.sass
// module chunks = main